<template>
  <div style="
      overflow: hidden;
      display: block;
      position: relative;
      margin-bottom: 0.12rem;
      min-height: calc(100% - 0.12rem);
      background: #000;
    " class="body_" v-on:mouseleave="bodyMouseout" v-on:mouseenter="bodyMouseover">
    <div class="SL_offerMaterialListView">
      <span v-if="props.message.status == 0" class="SL_offerMaterialListViewType">审核中</span>
      <!-- <span
        v-if="props.message.status == 1"
        class="SL_offerMaterialListViewType"
        >审核成功</span
      > -->
      <span v-if="props.message.status == -1" class="SL_offerMaterialListViewType" style="color: #FFF">审核驳回</span>
      <img @click="tg_video" :src="props.message.showImage || '../assets/LS1.png'" />
      <span class="SLCB_list_top_definition_list" v-show="immigrationChecked == true">
        <img @click.stop="iconMouseover()" src="../assets/icon_sgd.png" />
        <div v-show="iconChecked == true" :class="props.message.status == 1
          ? 'SLCB_functionList'
          : 'SLCB_functionList1'
          ">
          <!-- functionList -->
          <div @click.stop="SLCB_bj()">编辑</div>
          <div v-if="props.message.status == 1" @click.stop="SLCB_sjzt()">
            上架状态
          </div>
          <!-- <div @click.stop="SLCB_fx()">分享</div> -->
          <div @click.stop="SLCB_sc()" style="color: #f05a57">删除</div>
        </div>
      </span>
      <div class="SL_offerMaterialList_C">
        <span class="LSC_title">{{ props.message.title }}</span>
        <span class="LSC_time">{{ props.message.playTime }}</span>
      </div>
    </div>
    <!-- 作品弹窗组件 上架-->
    <el-dialog v-model="muk_listing" title="上架状态" class="muk_ kejianfangwei" align-center width="4.8rem"
      :close-on-click-modal="false">
      <div class="muk_listing_title">请选择上架状态</div>
      <el-radio-group v-model="from_muk_listing">
        <el-radio label="上架" value="0"></el-radio>
        <el-radio label="下架" value="1"></el-radio>
      </el-radio-group>
      <div class="dialog_b">
        <div class="dialog_b_qx" @click="muk_listing = false">取消</div>
        <div class="dialog_b_qd" @click="frommuklistingOk">确定</div>
      </div>
    </el-dialog>
    <!-- 素材弹窗组件 删除 -->
    <el-dialog title="" v-model="muk_delete" align-center width="480px" :close-on-click-modal="false">
      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img style="100%;height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
      </div>

      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        确定删除此作品
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="muk_delete = false">取消</div>
        <div class="dataBtnSubmit" @click="muk_ok()">确认</div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { Axios } from "../assets/js/ls_com_axios.js";
const router = useRouter();
const from_muk_listing = ref("下架");
let iconChecked = ref(false);
const props = defineProps({
  muk_edit: {
    type: Boolean,
    // required: true
  },
  message: {},
});
console.log(props.message);
const iconMouseover = function () {
  iconChecked.value = true;
};
//编辑
const SLCB_bj = function () {
  router.push({
    path: "/materiaPerfect",
    query: {
      id: props.message.id,
    },
  });
  iconChecked.value = false;
};
let muk_listing = ref(false);
//上架状态
const SLCB_sjzt = function () {
  iconChecked.value = false;
  muk_listing.value = true;
};
const emit = defineEmits([
  "ParticularsOverYse",
  "update:muk_edit",
  "deleteFunSucai",
]);
//分享
const SLCB_fx = function () {
  Axios(
    "POST",
    "/fodder/manage/share/" + props.message.id,
    null,
    false,
    function (res) {
      console.log(res.data);
      iconChecked.value = false;
      console.log(res.data.data.qrcodeUrl);
      emit("ParticularsOverYse", res.data.data.qrcodeUrl);
    }
  );
};

let muk_delete = ref(false);
//删除
const SLCB_sc = function () {
  iconChecked.value = false;
  muk_delete.value = true;
};
const muk_ok = function () {
  Axios(
    "DELETE",
    "/fodder/manage/remove/" + props.message.id,
    null,
    false,
    function (res) {
      console.log(res);
      emit("deleteFunSucai");
      muk_delete.value = false;
    }
  );
};
let immigrationChecked = ref(false); // 鼠标移入单模块触发
const bodyMouseover = function () {
  immigrationChecked.value = true;
  if (iconChecked.value == true) {
    iconChecked.value = false;
  }
};

const bodyMouseout = function () {
  immigrationChecked.value = false;
};
const frommuklistingOk = function () {
  if (from_muk_listing.value == "上架") {
    Axios(
      "POST",
      "/fodder/manage/online/" + props.message.id,
      false,
      false,
      function (res) {
        ElMessage({
          message: "上架成功",
          type: "success",
        });
        muk_listing.value = false;
      }
    );
  }
  if (from_muk_listing.value == "下架") {
    Axios(
      "POST",
      "/fodder/manage/offline/" + props.message.id,
      false,
      false,
      function (res) {
        ElMessage({
          message: "下架成功",
          type: "success",
        });
        muk_listing.value = false;
      }
    );
  }
};
/* 详情页 */
const tg_video = function () {
  if (props.message.status == 0) {
    ElMessage({
      showClose: true,
      message: "该素材还在审核中...",
      type: "warning",
    });
    return;
  }
  if (props.message.status == -1) {
    ElMessage({
      showClose: true,
      message: "该素材审核失败！",
      type: "warning",
    });
    return;
  }
  router.push({
    path: "/ShadowMaterialVideoParticulars",
    query: {
      id: props.message.id,
    },
  });
};
const groundingState = function () { };
</script>

<style scoped>
.SL_offerMaterialListView {
  background: #000;
}

.SL_offerMaterialListView>img {
  max-width: 100%;
  display: block;
  overflow: hidden;
  /* border-radius: .12rem; */
  position: relative;
  margin: 0 auto;
  max-height: 1.7rem;
}

.SL_offerMaterialList_A {
  padding: 0.12rem 0.16rem;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

/* 
	.SL_offerMaterialListView:hover .SL_offerMaterialList_B {
		bottom: 0rem;
	}

	.SL_offerMaterialListView:hover .SL_offerMaterialList_C {
		bottom: -0.6rem;
	} */

.SL_offerMaterialList_A>span {
  color: #fff;
  font-size: 0.12rem;
}

.SL_offerMaterialList_A_title {}

/* .SL_offerMaterialList_B {
		padding: 0.12rem 0.08rem;
		position: absolute;
		bottom: 0.0rem;
		left: 0;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		transition: bottom 0.5s
	} */

/* .SL_offerMaterialList_B:hover{
	bottom: -0.6rem;
} */

/* .SL_offerMaterialList_B, */
.SL_offerMaterialList_C {
  position: absolute;
  bottom: -0.6rem;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  pointer-events: none;
}

.SL_offerMaterialList_C {
  padding: 0.12rem 0.16rem;
  background: linear-gradient(180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.8) 100%);
  bottom: 0rem;
  /* transition: bottom 0.5s */
}

.SL_offerMaterialList_B_user,
.SL_offerMaterialList_B_imgList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialList_B_user {
  padding: 0.04rem;
  border-radius: 1rem;
  background: rgba(0, 0, 0, 0.25);
  font-size: 0.12rem;
  color: #fff;
}

.SL_offerMaterialList_B_user>img {
  width: 0.24rem;
}

.SL_offerMaterialList_B_uimgList>img {
  width: 0.32rem;
}

.SL_offerMaterialList_C {
  font-size: 0.12rem;
  color: #ffffff;
}

.SLCB_list_top_definition_list {
  position: absolute;
  top: 0.15rem;
  right: 0.17rem;
}

.SLCB_list_top_definition_list>img {
  width: 0.24rem;
  background: #fff;
  border-radius: 0.02rem;
  padding: 0.02rem;
}

.SLCB_functionList {
  position: absolute;
  bottom: -0.96rem;
  left: -0.75rem;
  background: #fff;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(32, 40, 58, 0.25);
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  padding: 0.04rem;
  width: 1rem;
  z-index: 0;
}

.SLCB_functionList1 {
  position: absolute;
  bottom: -0.76rem;
  left: -0.75rem;
  background: #fff;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(32, 40, 58, 0.25);
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  padding: 0.04rem;
  width: 1rem;
  z-index: 0;
}

.SLCB_functionList1>div {
  display: block;
  color: #333333;
  font-size: 0.12rem;
  text-align: center;
  padding: 0.06rem 0;

  border-radius: 0.02rem 0.02rem 0.02rem 0.02rem;
}

.SLCB_functionList1>view:hover {
  background: #f0f1f1;
}

.SLCB_functionList>div {
  display: block;
  color: #333333;
  font-size: 0.12rem;
  text-align: center;
  padding: 0.06rem 0;

  border-radius: 0.02rem 0.02rem 0.02rem 0.02rem;
}

.SLCB_functionList>view:hover {
  background: #f0f1f1;
}

.muk_listing_title {
  color: #000000;
  font-size: 0.14rem;
  margin-bottom: 0.16rem;
  margin-top: 0.21rem;
}

.dialog_b {
  margin-top: 0.2rem;
  display: flex;
  justify-content: center;
}

.dialog_b_qx {
  padding: 0.08rem 0.3rem;
  background: #fff;
  border: 0.01rem solid #333333;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  margin-right: 0.2rem;
  color: #333333;
  font-size: 0.14rem;
}

.dialog_b_qd {
  color: #ffffff;
  font-size: 0.14rem;
  padding: 0.08rem 0.3rem;
  background: #C01A26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.08rem 0.3rem;
}

.SL_offerMaterialListViewType {
  position: absolute;
  left: 0.16rem;
  top: 0.13rem;
  background: rgba(000, 000, 000, 0.5);
  border-radius: 4px;
  padding: 0.04rem;
  color: #333333;
  font-size: 14px;
  z-index: 1;
}

/deep/.el-radio__label {
  color: #333 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #C01A26 !important;
  background: #C01A26 !important;
}
</style>
